import { apiInterfaceForJson } from '../common/apiManager';

export const getAllAnalytes = (params) => {
    return apiInterfaceForJson('/analyte/v1/', 'GET', params);
};

export const getAnalyteById = (id) => {
    return apiInterfaceForJson('/analyte/v1/' + id, 'GET');
};

export const createAnalyte = (details) => {
    return apiInterfaceForJson('/analyte/v1/', 'POST', details);
};

export const updateAnalyte = (details) => {
    return apiInterfaceForJson('/analyte/v1/', 'PUT', details);
};

export const searchAnalytes = (query) => {
    return apiInterfaceForJson('/analyte/v1/search', 'POST', query);
};

export const deleteAnalyte = (details) => {
    return apiInterfaceForJson('/analyte/v1/delete', 'POST', details);
};